module.exports = __webpack_public_path__ + "static/media/noData.6dfd181e.svg";